import { render, staticRenderFns } from "./BhandarGharPos.vue?vue&type=template&id=0c8a996a&"
import script from "./BhandarGharPos.vue?vue&type=script&lang=js&"
export * from "./BhandarGharPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports